module.exports = __webpack_public_path__ + "img/04.dcd089d7.png";